module.exports = __webpack_public_path__ + "static/media/jira.b916ac2b.jpg";